import consola from 'consola';

export const appLogger = consola;

appLogger.wrapAll();
